import PaymentModal from './PaymentModal.svelte';

const paymentModalOptions = {
    styleWindow: {
        borderRadius: '0',
    },
    styleContent: {
        padding: 0,
    },
    closeButton: false,
    closeOnEsc: true,
    closeOnOuterClick: true,
};

export { paymentModalOptions, PaymentModal };
